import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { error } from 'console';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { ExcelDownloadService } from 'src/app/shared/services/excel-download.service';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { MasterService } from 'src/app/shared/services/master.service';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { ReportService } from 'src/app/shared/services/report.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-paywebcomponent',
  templateUrl: './paywebcomponent.component.html',
  styleUrls: ['./paywebcomponent.component.css']
})
export class PaywebcomponentComponent implements OnInit {
  email: any = '';
  amount: any = '';
  payWebList: any = [];

  constructor(
    private toastr: ToastrService
    , private datePipe: DatePipe
    , private regService: RegistrationService
    , private reportService: ReportService
    , private modalService: NgbModal
    , private masterService: MasterService
    , private authSvc: AuthenticationService
    , public activeModal: NgbActiveModal,
    public changeDetection: ChangeDetectorRef,
    private excelDownloadService: ExcelDownloadService, private activatedRoute: ActivatedRoute
    , private excelService: ExcelService
  ) { }

  ngOnInit(): void {
  }
  payNow() {
    const payload = {
      user_id: sessionStorage.getItem("loginId"),
      amount: this.amount,
      email: this.email
    };

    this.regService.post(`registration/pay-gate/initiate`, payload)
      .subscribe({
        next: (res: any) => {
          if (res.status === 'OK') {

            const payGateData = res.data;
            sessionStorage.setItem('payRequestId',payGateData.payRequestId)
            this.redirectToPayGate(
              payGateData.payRequestId,
              payGateData.checksum
            );

          } else {
            this.toastr.error(res.message);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastr.error(err.message);
        }
      });
  }
  redirectToPayGate(
    payRequestId: string,
    checksum: string
  ): void {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action =
      'https://secure.paygate.co.za/payweb3/process.trans';
    const payRequestInput =
      document.createElement('input');
    payRequestInput.type = 'hidden';
    payRequestInput.name = 'PAY_REQUEST_ID';
    payRequestInput.value = payRequestId;
    form.appendChild(payRequestInput);
    const checksumInput =
      document.createElement('input');
    checksumInput.type = 'hidden';
    checksumInput.name = 'CHECKSUM';
    checksumInput.value = checksum;
    form.appendChild(checksumInput);
    document.body.appendChild(form);
    form.submit();
  }

}
